import { render, staticRenderFns } from "./ReceiptOrInvoiceModal.vue?vue&type=template&id=1dab7b21&scoped=true&"
import script from "./ReceiptOrInvoiceModal.vue?vue&type=script&lang=ts&"
export * from "./ReceiptOrInvoiceModal.vue?vue&type=script&lang=ts&"
import style0 from "./ReceiptOrInvoiceModal.vue?vue&type=style&index=0&id=1dab7b21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dab7b21",
  null
  
)

export default component.exports